import { typedMemo } from '@utils';
import { lazy } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router';
import { AnimatedRoute } from './AnimatedRoute';
import styles from './AppRoutes.module.scss';

const BusinessPartner = lazy(
  () => import('../components/masterdata/business-partner/BusinessPartner'),
);
const Organization = lazy(
  () => import('../components/masterdata/organization/Organization'),
);
const ProjectManagement = lazy(
  () => import('../components/project-management/ProjectManagement'),
);
const ProjectManagementDetail = lazy(
  () =>
    import(
      '../components/project-management/project-management-detail/ProjectManagementDetail'
    ),
);

const E2ERoutes =
  import.meta.env.VITE_ENABLE_TEST_ROUTES === 'true'
    ? lazy(() => import('../../tests/test-components/E2ERoutes'))
    : null;

export const AppRoutes = typedMemo(() => {
  const location = useLocation();

  return (
    <div className={styles.container}>
      <Routes location={location}>
        <Route path="/" element={<Navigate to="/projects" replace />} />
        <Route
          path="/projects"
          element={
            <AnimatedRoute>
              <ProjectManagement />
            </AnimatedRoute>
          }
        />
        <Route
          path="/projects/new"
          element={
            <AnimatedRoute>
              <ProjectManagementDetail />
            </AnimatedRoute>
          }
        />
        <Route
          path="/business-partner"
          element={
            <AnimatedRoute>
              <BusinessPartner />
            </AnimatedRoute>
          }
        />
        <Route
          path="/organization"
          element={
            <AnimatedRoute>
              <Organization />
            </AnimatedRoute>
          }
        />
        {E2ERoutes && <Route path="/e2e/*" element={<E2ERoutes />} />}
      </Routes>
    </div>
  );
});
